import { authFetch, BASE_BACKEND_URL } from '../auth'
import React, { useState, useEffect } from 'react'
import NavBar from '../layout/NavBar'
import TopBar from '../layout/TopBar'
import ShowCollectionView from './view/ShowCollectionView'
import LoadingScreen from '../components/LoadingScreen'
import ErrorView from '../components/ErrorView'

const ShowCollectionApp = (props) => {
  const [searchPlaceholder] = useState('')
  const [id] = useState(window.location.href.split('/').slice(-1)[0])
  const [isFetching, setIsFetching] = useState(true)
  const [details, setDetails] = useState(null)
  const [defaultDetails, setDefaultDetails] = useState(null)
  const [error, setError] = useState(null)

 
  useEffect(() => {
    fetchTransactionDetails()
  }, [])

  const fetchTransactionDetails = () => {
    setIsFetching(true)
    authFetch(`${BASE_BACKEND_URL}/asset_collections/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (response.status === 401) window.location = '/'
        if (response.status === 404) return { error: true, message: 'No se encontró el activo' }
        return response.json()
      })
      .then((data) => {
        if (data.error) {
          setError(data.message)
        } else {
          setDetails(data)
          setDefaultDetails(data)
        }
        setIsFetching(false)
      })
      .catch((e) => console.log(e))
  }

return (
  <div>
    {isFetching ? (
      <LoadingScreen text="Cargando colección..." />
    ) : (
      <>
        {error ? (
          <ErrorView error={error} />
        ) : (
          <ShowCollectionView
            details={details}
            defaultDetails={defaultDetails}
          />
        )}
      </>
    )}
  </div>
)
}

export default ShowCollectionApp